// extracted by mini-css-extract-plugin
export default {"loginBlock":"RegisterLayout_loginBlock__r-9i1","loginTitle":"RegisterLayout_loginTitle__LCUAP","logo":"RegisterLayout_logo__7sfvM"};